const _excluded = ["aria-hidden", "className", "color", "disabled", "hoverable", "icon", "size"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import classNames from 'clsx';
import SVGCompatBox from "../SVG/SVGCompatBox";
import * as Icons from '@sail/icons/react/Icon';

class Icon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  componentDidCatch() {
    this.setState({
      hasError: true
    });
  }

  render() {
    const _this$props = this.props,
          {
      'aria-hidden': ariaHidden,
      className,
      color,
      disabled,
      hoverable,
      icon,
      size
    } = _this$props,
          iconProps = _objectWithoutProperties(_this$props, _excluded);

    const iconAsset = typeof icon === 'string' ? Icons[icon] : icon;
    const iconClasses = classNames('Icon', `Icon--${iconAsset.name}`, {
      'Icon--hoverable': hoverable
    }, className, {
      'Is--disabled': disabled
    });

    if (this.state.hasError) {
      return /*#__PURE__*/React.createElement("span", null);
    }

    return /*#__PURE__*/React.createElement(SVGCompatBox, _extends({}, iconProps, {
      "aria-hidden": ariaHidden,
      color: disabled ? 'disabled' : color,
      className: iconClasses,
      width: size,
      height: size,
      SvgElement: iconAsset.svg
    }));
  }

}

Icon.defaultProps = {
  'aria-hidden': true,
  color: 'default',
  size: 16
};
export default Icon;